import { render } from "./Interested.vue?vue&type=template&id=2a4cde65"
import script from "./Interested.vue?vue&type=script&lang=js"
export * from "./Interested.vue?vue&type=script&lang=js"
script.render = render

export default script